import { render, staticRenderFns } from "./unitList.vue?vue&type=template&id=818c3022&scoped=true&"
import script from "./unitList.vue?vue&type=script&lang=js&"
export * from "./unitList.vue?vue&type=script&lang=js&"
import style0 from "./unitList.vue?vue&type=style&index=0&id=818c3022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818c3022",
  null
  
)

export default component.exports